import { Box, Typography, keyframes } from "@mui/material";
import { useRef } from "react";

import type { TokenValleyBlockType } from "../../types/tokenValley";
import { getResourceGatheringIconBlockTypes } from "../../utils/getResourceGatheringIcon";

const floatUp = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-50px);
  }
`;

interface TypesProps {
  block: TokenValleyBlockType;
}

const AnimationBadge = ({ block }: TypesProps) => {
  const resourceAmountRef = useRef(Object.values(block.resource_stock)[0]);

  return (
    <Box
      zIndex={10}
      top={"-15px"}
      left={"-5px"}
      display={"flex"}
      position={"absolute"}
      sx={{
        animation: `${floatUp} 1s forwards`,
        pointerEvents: "none",
      }}
    >
      <img
        src={getResourceGatheringIconBlockTypes(block.block_type) || ""}
        alt="icon"
        style={{ width: "30px" }}
      />

      <Typography noWrap color="primary.dark" fontSize={"12px"} mt={1} ml={1}>
        + {resourceAmountRef.current?.toFixed(0)}
      </Typography>
    </Box>
  );
};

export default AnimationBadge;
